import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1 0 auto',
  },
}))

export default useStyles
